module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 6
// module chunks = 0